import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation,
} from '@angular/core';
import { EmptyStateBase } from '@qtek/shared/directives';

@Component({
  selector: 'qt-table-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf],
})
export class TableEmptyStateComponent extends EmptyStateBase {
  @HostBinding('class') private hostClass = 'empty-state';
}
